import cortexLockup from "./assets/cortex-lockup.png";

// CortexMark is the real Cortex brand lockup (fetched from the source repo's
// own design-system assets, docs/design/assets/cortex-lockup.png — navy +
// amber on a transparent background, matching this app's own --navy/--amber
// design tokens exactly). It has no light/reversed variant for dark
// backgrounds, so .mark gives it a white pill everywhere it's used
// (masthead, splash screen, login card) rather than recolouring the asset.
// Used in three places (AppShell, App's splash screen, LoginPage) — shared
// here so the img/alt markup isn't tripled.
export function CortexMark() {
  return (
    <div className="mark">
      <img src={cortexLockup} alt="Cortex" />
    </div>
  );
}
